import type { GraphQLAuthMode } from "@aws-amplify/core/internals/utils";
import type { ResourcesConfig } from "aws-amplify";

export const getAmplifyConfig = (): ResourcesConfig => {
  const webRedirectSignIn = process.env.NEXT_PUBLIC_WEB_REDIRECT_SIGN_IN;
  const webRedirectSignOut = process.env.NEXT_PUBLIC_WEB_REDIRECT_SIGN_OUT;

  // The Cognito Hosted UI domain is per-user-pool. Preview slots (QA2, QA3, ...)
  // reference QA1's pool (they do not have their own), so the Hosted UI subdomain
  // for each preview slot must be "qa", not "qa2"/"qa3"/etc. Set
  // NEXT_PUBLIC_COGNITO_STAGE=QA on each preview slot's Amplify branch to
  // override; defaults to NEXT_PUBLIC_ENV everywhere else.
  const cognitoStage =
    process.env.NEXT_PUBLIC_COGNITO_STAGE ||
    process.env.NEXT_PUBLIC_ENV ||
    "dev";

  return {
    Auth: {
      Cognito: {
        userPoolClientId: process.env
          .NEXT_PUBLIC_USER_POOL_WEB_CLIENT_ID as string,
        userPoolId: process.env.NEXT_PUBLIC_USER_POOL_ID as string,
        loginWith: {
          oauth: {
            domain: `rmh-platform-${cognitoStage.replace("_", "-")}.auth.${
              process.env.NEXT_PUBLIC_AWS_APPSYNC_REGION
            }.amazoncognito.com`,
            scopes: [
              "openid",
              "profile",
              "email",
              "aws.cognito.signin.user.admin",
            ],
            redirectSignIn: webRedirectSignIn ? webRedirectSignIn.split(",") : [],
            redirectSignOut: webRedirectSignOut ? webRedirectSignOut.split(",") : [],
            responseType: "code",
            providers: [
              {
                custom: process.env.NEXT_PUBLIC_WEB_OIDC_PROVIDER_NAME as string,
              },
            ],
          },
        },
      },
    },
    API: {
      GraphQL: {
        endpoint: process.env.NEXT_PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT as string,
        defaultAuthMode: process.env
          .NEXT_PUBLIC_AWS_APPSYNC_AUTHENTICATIONTYPE as GraphQLAuthMode,
        apiKey: process.env.NEXT_PUBLIC_APPSYNC_API_KEY as string,
        region: process.env.NEXT_PUBLIC_AWS_APPSYNC_REGION as string,
      },
      REST: {
        [process.env.NEXT_PUBLIC_ENV as string]: {
          endpoint: process.env.NEXT_PUBLIC_GATEWAY_URL as string,
        },
      },
    },
  };
};
